// Mutation hook - utworzenie stopki (1 per mailbox w MVP).
// POST /api/ui/sales-crm/mailbox/signatures
// Sprint 3 v4.1.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPostMailSignatureRequest,
  IPostMailSignatureResponse
} from 'api/types/signature';
import { MAIL_SIGNATURES_QUERY_KEY_BASE } from 'api/endpoints/useGetMailSignatures';

const postMailSignature = (
  body: IPostMailSignatureRequest
): Promise<IPostMailSignatureResponse> => axios.post('/sales-crm/mailbox/signatures', body);

export const usePostMailSignature = (
  options?: UseMutationOptions<IPostMailSignatureResponse, IError, IPostMailSignatureRequest>
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostMailSignatureResponse, IError, IPostMailSignatureRequest>(
    postMailSignature,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries([MAIL_SIGNATURES_QUERY_KEY_BASE]);
        options?.onSuccess?.(data, variables, context);
      }
    }
  );
};
